import { IsTest, getLang } from "@/utils/tools";
import { isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();
export const submitShare = async () => {
  const otherurl = 'api/flow/Wand-20230713071212-F43705326765d';
  const htmlurl = 'api/flow/Wand-20230714065440-Ffb803d471bcf';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    get_role_info: RoleInfo;
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20230713071006-F931b7049a0f2';
  const htmlurl = 'api/flow/Wand-20230714065440-F3b4e0ed894ef';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20230713071044-Fbe9554fd306a';
  const htmlurl = 'api/flow/Wand-20230714065440-F4a14f82acd0b';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};


interface GetLoginedInitInfoRes extends commomRes {
  data: {
    get_saved_role_info: RoleInfo; // 角色信息
    record_tag_list: string[]; // 记录信息
    siginin_days: number; // 签到天数
    user_has_present_list: [];// 已领取礼包列表
  };
}
// TODO htm 待确定
export const getLoginedInitInfo = async () => {
  const otherurl = 'api/flow/Wand-20230713071134-F589d7ea614e8';
  const htmlurl = 'api/flow/Wand-20230718073406-F3d80d0dcf5f8';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface SubmitSignParams {
  tag_id: string;
};

export const submitSign = async (params: SubmitSignParams) => {
  const otherurl = 'api/flow/Wand-20230713071441-F1d9af7480086';
  const htmlurl = 'api/flow/Wand-20230714065440-Fb3bf96350dfa';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params
    })
    .then((res) => res.data);
};

interface getRewardParams{
  id: number;
}
export const getReward = async (params: getRewardParams) => {
  const otherFlows = ['Wand-20230713071542-Fd365433e9724', 'Wand-20230714065829-F471a7020a0f7', 'Wand-20230714065840-F4073bd717e22']
  const htmlFlows = ['Wand-20230714065440-F17addb265cc1', 'Wand-20230714065704-Feb6645da8ed0', 'Wand-20230714065717-Fc64643501b41']
  const { id = 0 } = params;
  const otherurl = `api/flow/${otherFlows[id]}`;
  const htmlurl = `api/flow/${htmlFlows[id]}`;
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};
